var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"980px","show-close":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('video',_vm._b({staticClass:"video"},'video',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }